import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider, useApp } from "./context/AppContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppWidget from "./components/WhatsAppWidget";
import { Toaster } from "./components/ui/sonner";

import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Coverage from "./pages/Coverage";
import Support from "./pages/Support";
import SendPackage from "./pages/SendPackage";
import Track from "./pages/Track";
import Offers from "./pages/Offers";
import Auth from "./pages/Auth";
import CustomerDashboard from "./pages/CustomerDashboard";
import AdminPanel from "./pages/AdminPanel";
import StaffDashboard from "./pages/StaffDashboard";
import Inquiry from "./pages/Inquiry";
import StaffInquiries from "./pages/StaffInquiries";

function Protected({ children, roles }) {
  const { user, ready } = useApp();
  if (!ready) return <p role="status" data-testid="protected-page-loading" className="px-5 py-16 text-center">Loading…</p>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    const home = user.role === "admin" ? "/admin" : user.role === "employee" ? "/staff" : "/dashboard";
    return <Navigate to={home} replace />;
  }
  return children;
}

function Shell() {
  return (
    <>
      <Navbar />
      <main style={{ paddingTop: "var(--site-header-height, 148px)" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/coverage" element={<Coverage />} />
          <Route path="/support" element={<Support />} />
          <Route path="/send" element={<SendPackage />} />
          <Route path="/inquiry" element={<Inquiry />} />
          <Route path="/track" element={<Track />} />
          <Route path="/offers" element={<Offers />} />
          <Route path="/login" element={<Auth mode="login" />} />
          <Route path="/signup" element={<Auth mode="signup" />} />
          <Route path="/dashboard" element={<Protected roles={["customer"]}><CustomerDashboard /></Protected>} />
          <Route path="/staff" element={<Protected roles={["employee", "admin"]}><StaffDashboard /></Protected>} />
          <Route path="/staff/inquiries" element={<Protected roles={["employee", "admin"]}><StaffInquiries /></Protected>} />
          <Route path="/admin" element={<Protected roles={["admin"]}><AdminPanel /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppWidget />
      <Toaster position="top-right" />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
